/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Auto_Save_TitleInputs */



/**
* | output |
* | --- |
* | "Automatic Save Settings" |
*
* @param {Options_Backup_Auto_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_auto_save_title = /** @type {((inputs?: Options_Backup_Auto_Save_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Auto_Save_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres d'enregistrement automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen automatisch speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di salvataggio automatico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки автоматического сохранения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de guardado automático")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动保存设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動保存設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेटिंग्स स्वचालित रूप से सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvamento automático de configurações")
	return /** @type {LocalizedString} */ ("Automatic Save Settings")
});